import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

const TermsAndConditionContract = () => {
  return (
    <div className="container mx-auto py-12 px-4 sm:px-6 lg:px-8 max-w-5xl">
      {/* Header */}
      <div className="mb-8 text-center">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-purple-600 via-blue-500 to-cyan-400 bg-clip-text text-transparent mb-4">
          Enterprise Contract – Terms & Conditions
        </h1>
        <p className="text-gray-500 text-lg max-w-3xl mx-auto">
          Last updated:{" "}
          {new Date().toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
          })}
        </p>
        <Separator className="my-8" />
      </div>

      {/* Code of Conduct */}
      <Card className="mb-8 shadow-lg border-0 bg-white/50 backdrop-blur-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-800">
            1. Code of Conduct
          </CardTitle>
        </CardHeader>
        <CardContent className="text-gray-600 space-y-4">
          <ul className="list-disc pl-6 space-y-2">
            <li>Freelancer shall perform services with professionalism, integrity, and respect.</li>
            <li>Freelancer shall not engage in fraud, misrepresentation, or misuse of Client resources.</li>
            <li>Communication must remain professional, respectful, and limited to project-related matters.</li>
          </ul>
        </CardContent>
      </Card>

      {/* Confidentiality & NDA */}
      <Card className="mb-8 shadow-lg border-0 bg-white/50 backdrop-blur-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-800">
            2. Confidentiality & Non-Disclosure
          </CardTitle>
        </CardHeader>
        <CardContent className="text-gray-600 space-y-4">
          <p>
            The Freelancer agrees to keep all project-related information, client data, and deliverables strictly confidential. Disclosure to third parties is prohibited unless authorized in writing by the Client.
          </p>
          <p>
            Confidentiality obligations survive the termination of this contract.
          </p>
        </CardContent>
      </Card>

      {/* Intellectual Property */}
      <Card className="mb-8 shadow-lg border-0 bg-white/50 backdrop-blur-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-800">
            3. Intellectual Property
          </CardTitle>
        </CardHeader>
        <CardContent className="text-gray-600 space-y-4">
          <p>
            All deliverables produced under this contract become the sole property of the Client upon full payment. The Freelancer warrants that all work is original and free of third-party rights infringement.
          </p>
        </CardContent>
      </Card>

      {/* Communication */}
      <Card className="mb-8 shadow-lg border-0 bg-white/50 backdrop-blur-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-800">
            4. Communication
          </CardTitle>
        </CardHeader>
        <CardContent className="text-gray-600 space-y-4">
          <ul className="list-disc pl-6 space-y-2">
            <li>Official project communications must occur through the Digika platform unless otherwise approved.</li>
            <li>Freelancer must respond to Client requests within agreed timelines.</li>
            <li>Direct solicitation of Client’s staff, customers, or partners outside of this contract is prohibited.</li>
          </ul>
        </CardContent>
      </Card>

      {/* Security & Access Control */}
      <Card className="mb-8 shadow-lg border-0 bg-white/50 backdrop-blur-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-800">
            5. Data Security & Unauthorized Access
          </CardTitle>
        </CardHeader>
        <CardContent className="text-gray-600 space-y-4">
          <ul className="list-disc pl-6 space-y-2">
            <li>Freelancer shall not attempt unauthorized access to Client systems or networks.</li>
            <li>Access credentials, if provided, must be kept secure and not shared.</li>
            <li>Freelancer must return or securely delete all Client data upon completion of services.</li>
          </ul>
        </CardContent>
      </Card>

      {/* Payments */}
      <Card className="mb-8 shadow-lg border-0 bg-white/50 backdrop-blur-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-800">
            6. Payment & Fees
          </CardTitle>
        </CardHeader>
        <CardContent className="text-gray-600 space-y-4">
          <p>
            Payments shall be made in accordance with the agreed milestones via Digika’s escrow system. The Freelancer is responsible for their own taxes and regulatory compliance.
          </p>
        </CardContent>
      </Card>

      {/* Termination */}
      <Card className="mb-8 shadow-lg border-0 bg-white/50 backdrop-blur-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-800">
            7. Termination
          </CardTitle>
        </CardHeader>
        <CardContent className="text-gray-600 space-y-4">
          <p>
            Either party may terminate this contract for material breach. The Freelancer will be compensated for approved work completed up to termination. Confidentiality and intellectual property clauses remain in effect.
          </p>
        </CardContent>
      </Card>

      {/* Dispute Resolution */}
      <Card className="mb-8 shadow-lg border-0 bg-white/50 backdrop-blur-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-800">
            8. Dispute Resolution
          </CardTitle>
        </CardHeader>
        <CardContent className="text-gray-600 space-y-4">
          <p>
            Disputes shall first be resolved via Digika’s mediation service. If unresolved, disputes will proceed to binding arbitration under the laws of [Your Jurisdiction].
          </p>
        </CardContent>
      </Card>

      {/* Governing Law */}
      <Card className="mb-8 shadow-lg border-0 bg-white/50 backdrop-blur-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-800">
            9. Governing Law
          </CardTitle>
        </CardHeader>
        <CardContent className="text-gray-600">
          <p>
            This Agreement shall be governed by and construed in accordance with the laws of [Your Jurisdiction].
          </p>
        </CardContent>
      </Card>

      {/* Contact */}
      <Card className="mb-8 shadow-lg border-0 bg-white/50 backdrop-blur-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-gray-800">
            Contact Us
          </CardTitle>
        </CardHeader>
        <CardContent className="text-gray-600 space-y-4">
          <p>If you have any questions regarding these Terms & Conditions, please contact us:</p>
          <p className="p-4 bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg border border-blue-100 mt-2">
            <strong>Email:</strong> legal@dgkfreelancehub.com<br />
            <strong>Address:</strong> 123 Blockchain Boulevard, Crypto City, CC 12345<br />
            <strong>Phone:</strong> +1 (555) 123-4567
          </p>
        </CardContent>
      </Card>

      {/* Footer */}
      <div className="text-center mt-12 text-sm text-gray-500">
        <p>© {new Date().getFullYear()} DGK Freelance Hub. All rights reserved.</p>
      </div>
    </div>
  );
};

export default TermsAndConditionContract;
